import { getBasePath } from '../utilities/base-path.js';

const observer = new MutationObserver(mutations => {
  for (const { addedNodes } of mutations) {
    for (const node of addedNodes) {
      if (node.nodeType === Node.ELEMENT_NODE) {
        discover(node as Element);
      }
    }
  }
});

/**
 * Checks a node for undefined elements and attempts to register them.
 */
export async function discover(root: Element | ShadowRoot) {
  // const rootTagName = root instanceof Element ? root.tagName.toLowerCase() : '';
  // const rootIsCustomElement = rootTagName?.includes('-');
  const tags = [...root.querySelectorAll(':not(:defined)')]
    .map(el => el.tagName.toLowerCase())
    .filter(tag => tag.startsWith('outline-'));

  // If the root element is an undefined custom element, add it to the list
  // if (rootIsCustomElement && !customElements.get(rootTagName)) {
  //   tags.push(rootTagName);
  // }

  // Make the list unique
  if (tags) {
    const tagsToRegister = [...new Set(tags)];
    await Promise.allSettled(tagsToRegister.map(tagName => register(tagName)));
  }
}

/**
 * Registers an element by tag name.
 */
function register(tagName: string): Promise<void> {
  const path = getBasePath(`components/${tagName}/${tagName}.js`);

  // If the element is already defined, there's nothing more to do
  if (customElements.get(tagName)) {
    return Promise.resolve();
  }

  // Register it
  return new Promise((resolve, reject) => {
    import(path)
      .then(() => {
        return resolve();
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.error(
          `Error occurred during import of <${tagName}> from ${path}:`,
          error
        );
        reject(new Error(`Unable to autoload <${tagName}> from ${path}`));
      });
  });
}

// Initial discovery
discover(document.body);

// Listen for new undefined elements
observer.observe(document.documentElement, { subtree: true, childList: true });
